import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=516f5735&scoped=true"
import script from "./Notes.vue?vue&type=script&lang=js"
export * from "./Notes.vue?vue&type=script&lang=js"
import style0 from "./Notes.vue?vue&type=style&index=0&id=516f5735&prod&lang=scss"
import style1 from "./Notes.vue?vue&type=style&index=1&id=516f5735&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516f5735",
  null
  
)

export default component.exports